const element = document.createElement("div");
export const ELEMENT_STYLE_Computed = window.getComputedStyle(element);
export const ELEMENT_STYLE_VARS = Object.keys(ELEMENT_STYLE_Computed);
